import {
  deleteApiTracks,
  deleteApiTracksId,
  getApiTracksId,
  patchApiTracksIdStatus,
  patchApiTracksIdUploadStatus,
  postApiTracks,
  putApiTracksId,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const trackByIdQuery = createQuery({
  handler: getApiTracksId,
})

export const trackByIdUploadStatus = createMutation({
  handler: patchApiTracksIdUploadStatus,
})

export const trackCreate = createMutation({
  handler: postApiTracks,
})

export const trackUpdate = createMutation({
  handler: putApiTracksId,
})

export const trackToggleArchive = createMutation({
  handler: patchApiTracksIdStatus,
})

export const trackDelete = createMutation({
  handler: deleteApiTracksId,
})

export const trackMultipleDelete = createMutation({
  handler: deleteApiTracks,
})

export type DeleteApiTracks = typeof deleteApiTracks
export type DeleteApiTracksResponse = Awaited<ReturnType<DeleteApiTracks>>
export type DeleteApiTracksParams = Parameters<DeleteApiTracks>[0]
export type DeleteApiTracksParamsParams = NonNullable<
  DeleteApiTracksParams['params']
>
